import { create } from "zustand";
import { produce } from "immer";

const defaultData = {
  sessionFingerprint: false,
  initialized: false,
  loading: false,
  dismissing: false,
  alerts: [],
  currentIndex: 0,
  error: false,
};

export const useAgendaAlerts = create((set) => ({
  data: defaultData,
  actions: {
    setLoading: (loading) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.loading = loading;
        })
      ),
    setDismissing: (dismissing) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.dismissing = dismissing;
        })
      ),
    setAlerts: (alerts = [], sessionFingerprint = false) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.sessionFingerprint = sessionFingerprint;
          draft.data.alerts = alerts;
          draft.data.currentIndex = 0;
          draft.data.initialized = true;
          draft.data.error = false;
        })
      ),
    setError: (error, sessionFingerprint = false) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.sessionFingerprint = sessionFingerprint;
          draft.data.error = error;
          draft.data.initialized = true;
        })
      ),
    resetForSession: (sessionFingerprint = false) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data = {
            ...defaultData,
            sessionFingerprint,
          };
        })
      ),
    advanceAlert: () =>
      set((state) =>
        produce(state, (draft) => {
          const nextIndex = draft.data.currentIndex + 1;
          draft.data.currentIndex = nextIndex;
        })
      ),
    clear: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data = defaultData;
        })
      ),
  },
}));
